import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import {
  BarcodeActionTypes,
  ActionGetBarcodeDetailsSubmit,
  ActionGetBarcodeDetailsSubmitSuccess,
  ActionGetBarcodeDetailsSubmitError,
} from './types';
import { GetBarcodeFormPayload, Barcode, KitValidationResponse } from '../../models/barcode';
import BarcodeService from './effects';
import { APIError, ErrorResponse } from '../../helpers/types';

export const dispatchGetBarcodeDetailsSubmit = (payload: GetBarcodeFormPayload): ActionGetBarcodeDetailsSubmit => {
  return {
    type: BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT,
    payload,
  };
};

export const dispatchGetBarcodeDetailsSubmitSuccess = (payload: Barcode): ActionGetBarcodeDetailsSubmitSuccess => {
  return {
    type: BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT_SUCCESS,
    payload,
  };
};

export const dispatchGetBarcodeDetailsSubmitError = (e: APIError): ActionGetBarcodeDetailsSubmitError => {
  return {
    type: BarcodeActionTypes.ACTION_GET_BARCODE_DETAILS_SUBMIT_ERROR,
    error: e,
  };
};

// Action Creators
export const actionGetBarcodeDetails = (payload: GetBarcodeFormPayload) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchGetBarcodeDetailsSubmit(payload));
    return BarcodeService.get(payload).then((result: KitValidationResponse) => {
      const kitResponse = result[0];
      const kitResult: Barcode = {
        kitId: kitResponse.kitId,
        status: kitResponse.status,
        barcode: kitResponse.barcode,
      };
      return dispatch(dispatchGetBarcodeDetailsSubmitSuccess(kitResult));
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchGetBarcodeDetailsSubmitError(e.response));
    });
  };
};